import FileManagerContainer from "../../../Components/Applications/FileManager/FileManagerContainer";

const FileManager = () => {
  return <FileManagerContainer />;
};

export default FileManager;
